import { c as _c } from "react/compiler-runtime";
import { VillaSpecificationsPropertiesTypes } from "@website/accommodation-ui/villa-specifications/villa-specifications.types";
import { MaterialIcon } from "@website/icons/material";
import { numberConvert } from "@website/utils/number-convert";
import { useRouter } from "next/router";
export const VillaSpecifications = t0 => {
  const $ = _c(6);
  const {
    villaSpecifications
  } = t0;
  const router = useRouter();
  if (!villaSpecifications?.length) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-subtitle-1 md:text-headline-6">مشخصات اقامتگاه</div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== router?.locale || $[2] !== villaSpecifications) {
    t2 = villaSpecifications?.map(t3 => {
      const {
        iconName,
        title,
        description
      } = t3;
      return <div className="md:border-outline-thin flex w-full flex-row items-center gap-2 rounded-lg md:border md:p-6" key={`${iconName}-${title}`}><div><MaterialIcon className="text-headline-4 text-on-surface-medium-emphasis size-[30px] md:size-[32px]" name={iconName} variant="outlined" /></div><div className="flex flex-col gap-1"><span className="text-subtitle-2">{title}</span><span className="text-body-2 text-on-surface-medium-emphasis">{numberConvert(description, {
              locale: router?.locale
            })}</span></div></div>;
    });
    $[1] = router?.locale;
    $[2] = villaSpecifications;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="flex flex-col gap-4" id="hotel_specifications">{t1}<div className="grid grid-cols-1 gap-x-2 gap-y-6 md:grid-cols-2 md:gap-y-2">{t2}</div></div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};